module.exports = __webpack_public_path__ + "static/media/postepayBlue.a626c8b1.svg";